import React from 'react'
import { Event } from '@/types'

const EventState = ({ event }: { event: Event }) => {
  return (
    <>
      {
        event.state === 'register_now' && (
          <div
            className="w-fit px-3 py-0.5 bg-green-100 rounded-md justify-center items-center inline-flex">
              <span
                className="text-center text-emerald-900 text-sm font-medium">
                Register Now
              </span>
          </div>
        )
      }
      {
        event.state === 'ongoing' && (
          <div
            className="w-fit px-3 py-0.5 bg-sky-100 rounded-md justify-center items-center inline-flex">
              <span
                className="text-center text-blue-800 text-sm font-medium">
                Ongoing
              </span>
          </div>
        )
      }
      {
        event.state === 'upcoming' && (
          <div
            className="w-fit px-3 py-0.5 bg-indigo-100 rounded-md justify-center items-center inline-flex">
              <span
                className="text-center text-indigo-800 text-sm font-medium">
                Upcoming
              </span>
          </div>
        )
      }
      {
        event.state === 'closed' && (
          <div
            className="w-fit px-3 py-0.5 bg-gray-100 rounded-md justify-center items-center inline-flex">
              <span
                className="text-center text-gray-500 text-sm font-medium">
                Closed
              </span>
          </div>
        )
      }
    </>
  )
}

export default EventState
